import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import SizeGuideLinkAndModal from '../SizeGuide/SizeGuideLinkAndModal';
import SizeLegendLabel from './SizeLegendLabel';
import AllSizesButtonGroup from './AllSizesButtonGroup';
import AllInseamsButtonGroup from './AllInseamsButtonGroup';
import './styles.module.scss';

const ProductSizesForUnPersonalizedShoppingExperience = () => {
  const [state] = useProductDetailsPageContext();

  return (
    <>
      <Box styleName="size-title-container">
        <Text height="short" family="medium" scale="3" data-testid="size-title">
          Size
        </Text>
        <SizeGuideLinkAndModal />
      </Box>
      <SizeLegendLabel />
      <AllSizesButtonGroup />
      {state.inseamOptions.filter(inseam => inseam).length > 0 && (
        <>
          <Text height="short" family="medium" scale="3">
            Inseam
          </Text>
          <AllInseamsButtonGroup />
        </>
      )}
    </>
  );
};

export default React.memo(ProductSizesForUnPersonalizedShoppingExperience);
